import {Layout} from "../../../src/ts/layouts/Layout";
import { gsap } from 'gsap';
import { Draggable } from "gsap/Draggable";

export class ImageComparisonSlider extends Layout {

	private readonly SELECTOR_CONTAINER: string = '.component__reveal-slider';

	private $sliderElement: JQuery;
	private $sliderHandle: JQuery;
	private $sliderOptionalImages: JQuery;
	private $overlayImage: JQuery;
	private $sliderBounds: JQuery;

	constructor($elem: JQuery) {
		super($elem);

		gsap.registerPlugin(Draggable);

		this.$sliderElement = this.$layout.find(this.SELECTOR_CONTAINER);

		if (this.$sliderElement.length > 0) {
			this.$sliderHandle = this.$sliderElement.find('.handle');
			this.$sliderBounds = this.$sliderElement.find('.slider-container');
			this.$sliderOptionalImages = this.$sliderElement.find('.image-selector');

			this.$overlayImage = this.$sliderElement.find('.clipimage');

			if (this.$sliderOptionalImages.length > 1) {
				this.$sliderOptionalImages.on('click', (e) => this.onImageOverlaySwitch(e));
			}

			const overlayImage = this.$overlayImage[0];

			Draggable.create(this.$sliderHandle, {
				type: 'x',
				bounds: this.$sliderBounds,
				cursor: 'ew-resize',
				onDrag: function () {
					const minX = Math.abs(this.minX);
					const pathLength = minX + Math.abs(this.maxX);
					let handlePosition = this.x > 0 ? this.x + minX : minX - Math.abs(this.x);

					const percent = (handlePosition/pathLength) * 100;

					gsap.set(overlayImage, {
						clipPath: `polygon(${percent}% 0%, 100% 0%, 100% 100%, ${percent}% 100%)`
					});
				},
				onPress: function () {
					this.target.classList.add('pressed');
				},
				onRelease: function () {
					this.target.classList.remove('pressed');
				},
			});
		}

	}

	private onImageOverlaySwitch(e: JQuery.ClickEvent) {
		this.$overlayImage.attr('src', e.currentTarget.dataset.imgsrc);
	}

}

